/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/isScheduler */
import{isFunction as e}from"rxjs/dist/esm/internal/util/isFunction";function n(r){return r&&e(r.schedule)}export{n as isScheduler};
//# sourceMappingURL=isScheduler.mjs.map